var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 0.5C10.0899 0.5 13 3.41015 13 7C13 10.5899 10.0899 13.5 6.5 13.5C2.91015 13.5 0 10.5899 0 7C0 3.41015 2.91015 0.5 6.5 0.5ZM7.10938 10.4062C7.10938 10.7428 6.83655 11.0156 6.5 11.0156C6.16345 11.0156 5.89062 10.7428 5.89062 10.4062V6.75C5.89062 6.41345 6.16345 6.14062 6.5 6.14062C6.83655 6.14062 7.10938 6.41345 7.10938 6.75V10.4062ZM6.5 3.03125C6.05127 3.03125 5.6875 3.39502 5.6875 3.84375C5.6875 4.29248 6.05127 4.65625 6.5 4.65625C6.94873 4.65625 7.3125 4.29248 7.3125 3.84375C7.3125 3.39502 6.94873 3.03125 6.5 3.03125Z",
    fill: "#00B0CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.d9cf3c5986ee394657ceb193c5c96454.svg";
export { ForwardRef as ReactComponent };